import { buildCanonicalUrl } from 'components/seo/canonical/build-canonical-url';
import { Locale } from 'config/constants/locales';
import { useCanonicalConfig } from 'config/use-config';
import type { ReactElement } from 'react';
import { useIntl } from 'react-intl';
import { stripLocalePathPrefix } from 'utils/i18n/strip-locale-path-prefix';
import { withLocalePathPrefix } from 'utils/i18n/with-locale-path-prefix';

export const resolvedCanonical = (pageUrl: string): ReactElement => (
  <>
    <link rel="canonical" href={pageUrl} />
    <meta name="og:url" property="og:url" content={pageUrl} />
  </>
);

const Canonical = (url: string | null | undefined): ReactElement => {
  const { locale } = useIntl();
  const canonicalConfig = useCanonicalConfig(locale as Locale);

  if (url && /^https?:\/\//i.test(url)) return resolvedCanonical(url);

  const pageUrl = buildCanonicalUrl({
    host: canonicalConfig.frontendUrl,
    pathname: url
      ? withLocalePathPrefix(stripLocalePathPrefix(url), locale, canonicalConfig.locale)
      : url,
  });

  return resolvedCanonical(pageUrl);
};

export default Canonical;
